import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full bg-[#0f172a] text-[#faf7f2] overflow-hidden py-16 md:py-24 px-4" data-id="element-205">
      {/* Ambient Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#5b8a7a] opacity-10 blur-[100px] rounded-full pointer-events-none" data-id="element-206" />

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-207">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-[#7fb3a0] tracking-widest text-sm font-medium uppercase mb-6" data-id="element-208">
          Para madres primerizas · 0–12 semanas
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-serif text-4xl md:text-6xl lg:text-7xl font-medium leading-tight mb-6 text-[#faf7f2]" data-id="element-209">
          A las 2AM no piensas: <br data-id="element-210" />
          <span className="italic text-[#e8856c]" data-id="element-211">sigues el guion.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-[#cbd5e1] max-w-2xl mb-10 font-light leading-relaxed" data-id="element-212">
          Guiones de 90 segundos + Árbol de decisión para sobrevivir despertares
          nocturnos sin colapsar.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="relative mb-12 w-full max-w-md mx-auto" data-id="element-213">
          <div className="absolute inset-0 bg-[#e8856c] blur-[40px] opacity-20 rounded-full" data-id="element-214" />
          <img src="https://cdn.magicpatterns.com/uploads/qYPr3tNGUQvGVjKthNWUtJ/heylloyd-image-1771269354253.jpg" alt="2AM Newborn Sleep Scripts on Tablet" className="relative z-10 w-full h-auto rounded-xl shadow-2xl animate-float border border-white/10" data-id="element-215" />
        </motion.div>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} onClick={() => {
        document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="bg-[#e8856c] text-white px-10 py-4 rounded-full text-lg font-medium shadow-[0_0_20px_rgba(232,133,108,0.4)] hover:shadow-[0_0_30px_rgba(232,133,108,0.6)] transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer" data-id="element-216">
          Quiero el guion
          <ArrowRight className="w-5 h-5" data-id="element-217" />
          <span className="line-through opacity-60 text-sm" data-id="element-218">$19</span>
          <span className="font-bold" data-id="element-219">$6.36</span>
        </motion.button>
      </div>
    </section>;
}